import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from "react-router-dom"
import { useLocation } from "react-router";
import { Grid, Collapse } from 'antd-mobile';
import BpmToast from 'components/BpmToast';
import { BpmTabBar } from "components/TabBar/BpmTabBar";
import { UserContext } from 'utils/getContext'
import { getResultData } from "api/api";
import { userType, urlType, TRUE_FLAG_NUM } from 'utils/constant';
import 'static/css/service.css'

const { USER } = userType

export function Service(props) {
  const navigate = useNavigate()
  const myContext = useContext(UserContext)
  const { userInfo } = myContext
  const { state } = useLocation()
  const defaultActiveKey = state?.defaultActiveKey || ["1", "2", "3", "4"]
  const [data, setData] = useState([])
  const arr = { key1: [], key2: [], key3: [], key4: [] }

  /** 初始化页面数据 */
  useEffect(() => {
    getData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /**处理即将跳转的页面 */
  function handleNavigate(item) {
    const url = item?.furlh5 || item?.furl
    const navigateType = item?.ftype === TRUE_FLAG_NUM
    if (navigateType) {
      // 根据url特别处理
      if (url === '/subsidy') {
        const newUrl = '/newSubsidy'
        navigate(newUrl)
      } else if (url === '/affirmEmploy') {
        const newUrl = '/newAffirmEmploy'
        navigate(newUrl)
      } else {
        if (url.indexOf('http') !== -1) {
          window.location.href = url
        } else {
          navigate(url)
        }
      }
    } else {
      window.location.href = item?.furl
    }
  }


  function handleServiceClick(item) {
    // navigate('affirmEmploy')
    // return
    /** 判断用户是否登录 */
    if (!userInfo) {
      return BpmToast('请先登录')
    }
    let type
    if (userInfo.type === USER) {
      type = urlType.USER
    } else {
      type = urlType.UNIT
    }

    // 判断是个人用户还是企业用户
    if (type && type === item?.fobject) {
      // if (item.fischeck === 0) {
      // 不需要验证直接跳转对应页面
      handleNavigate(item)
      // } else {
      // 需要验证
      // 跳转到验证页面,item和handleNavigate传递给下一个页面
      // navigate('/conditionCheck', { state: { item } })
      // }

    } else {
      // 绕过判定
      // if (process.env.NODE_ENV === 'development') {
      //   navigate(item?.furl)
      //   return
      // }
      // 正常判定
      // 判断是个人用户还是企业用户
      if (item?.fobject === urlType.USER) {
        // 个人用户
        return BpmToast('该服务仅对个人用户开放')
      } else if (item?.fobject === urlType.UNIT) {
        // 企业用户
        return BpmToast('该服务仅对企业用户开放')
      } else {
        return BpmToast('您不符合该服务的使用条件')
      }
    }
  }

  /** 获取页面数据 */
  async function getData() {
    const parm = {
      serviceId: 101,
      params: { pageIndex: 0, pageSize: 1, object: 1 }
    }
    const { code, data } = await getResultData(parm)
    if (code === 200) {
      // 过滤data中fh5isshow不等于1的数据
      const h5Data = data.filter(item => item.fh5isshow === 1)
      setData(h5Data)
    } else {
      BpmToast('获取数据失败')
    }
  }


  /** 渲染页面 */
  data.forEach(item => {
    if(!item.fitemtype)return
    arr[`key${item.fitemtype}`].push(
      <div
        className='serviceContent'
        key={item.id}
        onClick={() => handleServiceClick(item)}
      >
        <img src={'/images/' + item.ficon} alt={item.name}></img>
        <div className='serviceDetail'>
          {item.name}
        </div>
      </div>
    )
  })

  const directory = [
    {
      key: 1,
      title: '就业创业',
      content: arr.key1
    },
    {
      key: 2,
      title: '失业保险',
      content: arr.key2
    },
    {
      key: 3,
      title: '创业培训',
      content: arr.key3
    },
    {
      key: 4,
      title: '就业帮扶',
      content: arr.key4
    }
  ]

  return (
    <>
      <div className='background'>
        <Collapse defaultActiveKey={defaultActiveKey} className='title1'>
          {
            directory.map(item =>
              <Collapse.Panel key={item.key} title={item.title}>
                <Grid columns={4} gap={6}>
                  {item.content}
                </Grid>
              </Collapse.Panel>
            )
          }
        </Collapse>
      </div>
      {/* 底部导航栏 */}
      <BpmTabBar />
    </>
  )
}